import MUSIC_CONFIGS from "game-files/audio/MUSIC_CONFIGS";
import { SceneMusicType } from "game-engine/types";

export const TestScenesMusic: SceneMusicType = {
  musicConfigId: MUSIC_CONFIGS.Test_01.id,
  volume: 1,
};
